import React from 'react';
import { Card, Grid } from '@mui/material';
import { useOutletContext } from 'react-router-dom';

import JobContainer from './JobContainer';
import { useSelector } from 'react-redux';
import Loader from '../../components/loader/Loader';

const JobsApplied = () => {
    const { candidateJobsApplied } = useSelector((state) => state?.candidateState);
    const [mobileView] = useOutletContext();
    return (
        <Card sx={{ mx: mobileView ? 4 : 8, my: 4, p: 4 }}>
            <Grid container spacing={3}>
                {candidateJobsApplied ? (
                    candidateJobsApplied?.map((job, index) => (
                        <JobContainer key={index} job={job} index={index} />
                    ))
                ) : (
                    // <Loader />
                    ''
                )}
            </Grid>
        </Card>
    );
};

export default JobsApplied;
